module.exports = __webpack_public_path__ + "static/media/contact.688467cd.png";